const t = new Date().getTime() / 60000
const timeend = Math.floor(t)
const timestart = Math.floor(t)
const countclick = [0]
export default
{
  timestart,
  timeend,
  countclick
}
